import {ReportFileFiltersType} from "../hooks/useCsReportFileQuery";
import {getLastWeekDateTimeRange} from "../../../../utils/dateTimeUtils";

// 获取最近一周的日期范围作为默认值
const [startDate, endDate] = getLastWeekDateTimeRange();

export const ReportFileInitialValue: ReportFileFiltersType = {
    type: undefined,
    name: undefined,
    reportDate: [startDate, endDate],
    operatorId: undefined,
}; 